import { Injectable } from '@angular/core';
import { GroupsApiService } from '@core/services/groups-api.service';
import { ModalController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  sendAgreementForSignatures,
  sendAgreementForSignaturesFailure,
  sendAgreementForSignaturesSuccess,
} from '@shared/actions/send-agreement-for-signatures.actions';
import { ToastService } from '@shared/services/toast.service';
import { catchError, map, of, switchMap, tap } from 'rxjs';
@Injectable()
export class SendAgreementForSignaturesEffects {
  constructor(
    private actions$: Actions,
    private groupsApiService: GroupsApiService,
    private toastService: ToastService,
    private modalController: ModalController,
  ) {}

  sendAgreementForSignatures$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendAgreementForSignatures),
      switchMap((action) => {
        return this.groupsApiService.sendAgreementForSignatures(action.groupId, action.email).pipe(
          map(() => {
            return sendAgreementForSignaturesSuccess({ groupId: action.groupId });
          }),
          catchError((error) => {
            return of(sendAgreementForSignaturesFailure({ error }));
          }),
        );
      }),
    ),
  );

  sendAgreementForSignaturesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(sendAgreementForSignaturesSuccess),
        tap(() => {
          this.modalController.dismiss(undefined, undefined, 'send-agreement-for-signatures');
          this.toastService.showToast('success', 'Agreement sent for signatures successfully.', 3000);
        }),
      ),
    { dispatch: false },
  );

  sendAgreementForSignaturesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(sendAgreementForSignaturesFailure),
        tap(({ error }) => {
          const errorMessage =
            typeof error.error?.errors === 'string'
              ? error.error.errors
              : 'Failed to send agreement for signatures. Please try again later.';

          this.toastService.showToast('error', errorMessage, 10000);
        }),
      ),
    { dispatch: false },
  );
}
